import { render } from "./StatsEditor.vue?vue&type=template&id=e6162eb8&scoped=true"
import script from "./StatsEditor.vue?vue&type=script&lang=js"
export * from "./StatsEditor.vue?vue&type=script&lang=js"

import "./StatsEditor.vue?vue&type=style&index=0&id=e6162eb8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6162eb8"]])

export default __exports__